<template>
  <div class="wrapper border-bottom white-bg page-heading">
		<div class="container">
			<div class="row">
				<div class="col-xs-12">
          <heading-loading v-if="loading"></heading-loading>
					<h1 v-else><i class="far fa-truck-container m-r-sm"></i> {{ truck.registration }}</h1>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
  import { mapState } from 'vuex'
  import { headingLoading } from 'mixins'

  export default {
    mixins: [headingLoading],

    computed: mapState('truck', ['truck'])
  }
</script>



// WEBPACK FOOTER //
// EditHeading.vue?56d3d5c0